import { ReactNode, useEffect, useContext, useState } from "react";
import { CurrentEnvironment, getRoleRank, mapBrand, mapRole } from "../utils/helpers";
import useWebSocket from "../hooks/useWebSocket";
import { useSlugs } from "../../core/hooks/useSlugs";
import { WebSocketContext } from "../utils/chatbotWSContext";
import { useGetChatUserRolesQuery } from "../api/chatbotAPI";
import { ChatbotStateContext, ChatbotStateDispatchContext } from "../utils/chatbotContext";

export const ChatbotCtrls = ({ children }: { children: ReactNode }) => {
  const { brandSlug } = useSlugs();
  const { data: roles } = useGetChatUserRolesQuery();
  const [connected, setConnected] = useState(false);
  const dispatch = useContext(ChatbotStateDispatchContext);
  const chatbotCurrentState = useContext(ChatbotStateContext);
  const { connect, startNewConversation, submitQuestionToWebSocket, submitFeedback, getConversationHistory, getConversationMssgs, stopWebSocketStream, transferToZendesk } = useWebSocket();

  useEffect(() => {
    dispatch({ type: "UPDATE_SELECTED_BRAND", payload: mapBrand(brandSlug) });
    if (chatbotCurrentState.currentState === "Connected State") {
      getConversationHistory(mapBrand(brandSlug), chatbotCurrentState.selectedRole);
      startNewConversation(mapBrand(brandSlug), chatbotCurrentState.selectedRole);
    }
  }, [brandSlug, dispatch, chatbotCurrentState.selectedRole, chatbotCurrentState.currentState, getConversationHistory, startNewConversation]);

  useEffect(() => {
    const currentEnv = import.meta.env.MODE === "prod" ? "prod" as CurrentEnvironment : "staging" as CurrentEnvironment;

    if (roles) {
      const roleNames = roles.map((role) => {
        return role.roleName;
      });

      const mapUserRolesForChatbot = roleNames.map((roleName: string) => {
        return {
          displayRole: roleName,
          wingmanRole: mapRole(roleName, currentEnv),
          rank: getRoleRank(mapRole(roleName, currentEnv))
        };
      });

      // Sort roles by Rank
      if (mapUserRolesForChatbot.length > 1) {
        mapUserRolesForChatbot.sort((a, b) => {
          return a.rank - b.rank;
        });
      }

      dispatch({ type: "UPDATE_SELECTED_ROLE", payload: mapUserRolesForChatbot[0] });
    }
  }, [roles, dispatch]);

  useEffect(() => {
    if (chatbotCurrentState.selectedBrand !== "" && chatbotCurrentState.selectedRole !== "" && !connected) {
      connect(chatbotCurrentState.selectedBrand, chatbotCurrentState.selectedRole);
      setConnected(true);
    }
  }, [chatbotCurrentState.selectedBrand, chatbotCurrentState.selectedRole, connect, connected]);

  return (
    <WebSocketContext.Provider value={{ connect, startNewConversation, submitQuestionToWebSocket, submitFeedback, getConversationHistory, getConversationMssgs, stopWebSocketStream, transferToZendesk }}>
      {children}
    </WebSocketContext.Provider>
  );
}; 